// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout__footer[data-v-b675a714]{border-top:1px solid #d8dbe0}@media only screen and (max-width:575px){.layout__footer[data-v-b675a714]{text-align:center}}.layout__footer .col__footer--right[data-v-b675a714]{text-align:right}@media only screen and (max-width:575px){.layout__footer .col__footer--right[data-v-b675a714]{text-align:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
